import request from '@/utils/request';

const PATH = '/hits';

export const addViewCount = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});
